
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 19.5c2.488 0 4.5 2.012 4.5 4.5s-2.012 4.5-4.5 4.5a4.497 4.497 0 01-4.5-4.5c0-2.488 2.012-4.5 4.5-4.5zM19.5 13c0 2.488 2.012 4.5 4.5 4.5s4.5-2.012 4.5-4.5-2.012-4.5-4.5-4.5a4.497 4.497 0 00-4.5 4.5zm0 22c0 2.487 2.012 4.5 4.5 4.5s4.5-2.013 4.5-4.5-2.012-4.5-4.5-4.5a4.497 4.497 0 00-4.5 4.5z","fill":"#535353"}})])
          )
        }
      }
    